import React from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { categories } from '../data/cardInfo'


export const Wrapper = styled.div`
  padding: 1rem 2rem;
  max-width:50em;
`

export const ButtonList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2em 1em;
  align-items: center;
  `

export const LinkButton = styled(Link)`
  text-decoration: none;
  margin: 1em 1em;
  padding: 1em;
  max-width: 15em;
  width:100%;

  font-family: 'Monaco';
  color: white;
  background: ${props => props.color}
`

export const Button = styled.button`
  text-decoration: none;
  border: none;
  margin: 1em 1em;
  padding: 1em 3em;
  font-family: 'Monaco';
  cursor:pointer;
  color: white;
  background: ${props => props.color}
`

const StartPage = () => {
  return (
    <Wrapper>
      <h2>Bland botar och troll</h2>
      <h5>
      Hur mycket kan du om informationspåverkan på nätet? <br />
      Testa dina kunskaper här.
      </h5>
      
      <ButtonList>
        <LinkButton color={categories[1].topColor} to='/train'>Träna på begrepp</LinkButton>
        <LinkButton color={categories[0].topColor} to='/difficulty'>Starta quiz</LinkButton>
        <LinkButton color={categories[2].topColor} to='/about'>Om</LinkButton>
      </ButtonList>
    </Wrapper>
  )
}

export default StartPage
